module.exports = __webpack_public_path__ + "img/5.cb7f0d93.png";